/**
 * Checks if the given account has the "core_classifiers" feature enabled.
 * @param {object} account - The account object which may contain a `flipper_features` array.
 * @returns {boolean} `true` if `account.flipper_features` includes "core_classifiers"; otherwise `false`.
 */
export function isCoreClassifiersEnabled(account: object): boolean {
  return Boolean(account?.flipper_features?.includes('core_classifiers'))
}
